import { trackEvent, trackPageview } from "@garantidos/utils/tracking"

const simulationStarted = () => {
  trackEvent({ segment: "Simulation Started" })
}

const pageview = (hashedCpf, currentStep) => {
  const ga4 = {
    customPath: `credito/cgimovel/quitado/contratacao/simulacao/inicio-simulacao-${currentStep}`,
    hashedCpf,
    implementationTeam: "cgi:v01"
  }

  const ga = {
    label: `IT:NL:NCC:CGI:Simulador:InicioSimulacao:${currentStep}`,
    hashedCpf
  }

  const segment = `${currentStep} visualizou página`

  trackPageview({ ga, ga4, segment })
}

const advance = (hashedCpf, currentStep) => {
  const ga4 = {
    customPath: `credito/cgimovel/quitado/contratacao/simulacao/inicio-simulacao-${currentStep}`,
    hashedCpf,
    implementationTeam: "cgi:v01",
    detail: "btn:avancar",
    eventName: "click",
    isSoftLead: true
  }

  const ga = {
    label: "BTN:Simulador:ColetaCPF",
    action: "Simulador",
    hashedCpf
  }

  trackEvent({ ga, ga4, segment: `${currentStep} clicou botão avançar` })
}

const back = (hashedCpf, currentStep) => {
  const ga4 = {
    customPath: `credito/cgimovel/quitado/contratacao/simulacao/inicio-simulacao-${currentStep}`,
    hashedCpf,
    implementationTeam: "cgi:v01",
    detail: `inicio-simulacao-${currentStep}-voltar`,
    eventName: "click"
  }

  const ga = {
    label: "BTN:Simulador:Voltar",
    action: "Simulador",
    hashedCpf
  }

  trackEvent({ ga, ga4 })
}

const backHome = (hashedCpf, currentStep) => {
  const ga4 = {
    customPath: `credito/cgimovel/quitado/contratacao/simulacao/inicio-simulacao-${currentStep}`,
    hashedCpf,
    implementationTeam: "cgi:v01",
    detail: "btn:voltar-inicio",
    eventName: "click"
  }
  trackEvent({ ga4 })
}

const alert = (hashedCpf, error, currentStep) => {
  const ga4 = {
    customPath: `credito/cgimovel/quitado/contratacao/simulacao/inicio-simulacao-${currentStep}`,
    hashedCpf,
    implementationTeam: "cgi:v01",
    eventName: "alert",
    description: "erro",
    detail: error.message
      ?.toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replaceAll(/ /g, "-")
      .replaceAll(/!/g, "")
  }

  trackEvent({ ga4 })
}

const ladingPage = (hashedCpf) => {
  const ga = {
    label: "BTN:Inicio:Continuar",
    action: "Inicio",
    hashedCpf
  }
  const ga4 = {
    customPath: "inicio/landing-page",
    hashedCpf,
    implementationTeam: "cgi:v01",
    detail: "landing-page-simule-agora",
    eventName: "click"
  }

  trackEvent({ ga, ga4 })
}

export {
  pageview,
  advance,
  alert,
  back,
  backHome,
  ladingPage,
  simulationStarted
}
